import type { SubLayoutState } from './types'

export const selectSubLayoutItem = (state: { subLayout: SubLayoutState }) => state.subLayout
